// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__12uL_","log":"ModalInventoryLogs_log__2qhqx","date":"ModalInventoryLogs_date__ql5hD","userName":"ModalInventoryLogs_userName__3ngX1"};